import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import OpeningTime, { OpeningTimeDto } from "../../OpeningTimes/OpeningTime";
import { IdType } from "../../Utils/IdType";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";
import { OpeningTimeMapper } from "../../OpeningTimes/OpeningTimeMapper";

export const useFetchSupplierOpeningTimes = (parentId: IdType) => {
  return useQuery<OpeningTime[], Error>({
    queryKey: openingTimeWithIdQueryKey(parentId, "suppliers"),
    queryFn: () => fetchOpeningTimesForSupplier(parentId),
    onError: () => {
      toast.error(
        `An error occurred when retrieving opening times for the supplier with Id ${parentId}`
      );
    },
  });
};

const fetchOpeningTimesForSupplier = async (parentId: IdType) => {
  const { data: openingTimes } = await axios.get<OpeningTimeDto[]>(
    openingTimesUrls.openingTimesForSupplierWithId(parentId)
  );

  return OpeningTimeMapper.toOpeningTimes(openingTimes);
};
